

import React, { useState } from "react";
import CartTable2 from "../../../../components/AdminTable/CardTable2";
// import Dropdown from "../../../../components/AdminDropdown/Dropdown";

function InventoryReport() {
  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",
    },
    {
      header: "Ingredient (Code)",
      accessorKey: "Ingredient (Code)",
    },
    {
      header: "Category",
      accessorKey: "Category",
    }, {
        header: "Stock Qty/Amount",
        accessorKey: "Stock Qty/Amount",
      }, {
        header: "Alert Qty/Amount",
        accessorKey: "Alert Qty/Amount",
      },
  ]);
  const [data] = useState([]);
  const [buttonDataa] = useState([
    {
      buttonText: "Submit",
    },
    {
        buttonText: "Ingredent in Alert",
      },
  ]);

  const [selectButton] = useState([
    {
        placeholder: "Category",
      }, {
        placeholder: "Ingredent",
      }, {
        placeholder: "Food Menu",
      },
  ]);
  return (
    <main>
      <CartTable2
        data={data}
        columns={columns}
        heading={"Inventory "}
        buttonDataa={buttonDataa}
        selectButton={selectButton}
      />
     
    </main>
  );
}

export default InventoryReport;
